(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dcv-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
  var cfgEl = document.getElementById('dcv-config');
  if (!cfgEl) return;
  var cfg = {};
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  // ---------- Age gate (30-day cookie, §6) ----------
  var gate = document.getElementById('dcv-gate');
  function hasAgeCookie(){ return document.cookie.indexOf('dc_age=1') !== -1; }
  if (gate) {
    if (!hasAgeCookie() && !cfg.designMode) { gate.hidden = false; }
    var yes = gate.querySelector('[data-age-yes]');
    if (yes) yes.addEventListener('click', function () {
      document.cookie = 'dc_age=1;max-age=2592000;path=/;SameSite=Lax';
      gate.hidden = true;
    });
  }

  // ---------- UTM + hero variant persistence (§5/§7) ----------
  var params = new URLSearchParams(location.search);
  var attribution = {};
  ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(function(k){
    if (params.get(k)) attribution[k] = params.get(k);
  });
  var v = (params.get('v') || cfg.defaultVariant || 'b').toLowerCase();
  if (!cfg.variants[v]) v = cfg.defaultVariant || 'b';
  attribution.hero_variant = v;

  // ---------- Apply hero variant ----------
  var data = cfg.variants[v];
  if (data) {
    var h1 = document.getElementById('hero-h1');
    var sub = document.getElementById('hero-sub');
    var img = document.getElementById('hero-img-el');
    if (h1 && data.h1) h1.textContent = data.h1;
    if (sub && data.sub) sub.textContent = data.sub;
    if (img && img.tagName === 'IMG' && data.img) img.src = data.img;
  }
  // Expose variant to Klaviyo (identify) so native forms can capture it
  window._klOnsite = window._klOnsite || [];

  // ---------- Analytics helpers ----------
  function track(fbEvent, gaEvent, payload) {
    if (window.fbq && fbEvent) { try { fbq('track', fbEvent, payload || {}); } catch(e){} }
    if (window.gtag && gaEvent) { try { gtag('event', gaEvent, payload || {}); } catch(e){} }
  }
  track(null, 'view_item', { items: [{ item_id: cfg.variantId }] });

  // ---------- Add to cart (real Shopify cart, §3) ----------
  var drawer = document.getElementById('dcv-drawer');
  var FREE_QTY = cfg.freeShipQty || 2;
  var qtyValEl    = drawer ? drawer.querySelector('[data-qty-val]') : null;
  var shipMsgEl   = drawer ? drawer.querySelector('[data-ship-msg]') : null;
  var cartNameEl  = drawer ? drawer.querySelector('.dcv-cart-name') : null;
  var checkoutBtnEl = drawer ? drawer.querySelector('[data-checkout]') : null;
  var decBtn = drawer ? drawer.querySelector('[data-qty-dec]') : null;
  var incBtn = drawer ? drawer.querySelector('[data-qty-inc]') : null;

  function openDrawer(){ if (drawer) drawer.hidden = false; }
  function closeDrawer(){ if (drawer) drawer.hidden = true; }

  // Read the live cart and how many of OUR bottle are in it.
  function getCart(){ return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function(r){ return r.json(); }); }

  var shownQty    = 0;   // what the shopper currently sees in the stepper
  var lastWritten = 0;   // last quantity we sent to the server
  var ourKey      = '';  // line item key of our bottle, from the last cart read

  // Pure DOM, no network — lets the stepper repaint instantly and reconcile later.
  function paintQty(qty){
    if (qtyValEl) qtyValEl.textContent = qty;
    if (shipMsgEl) {
      if (qty <= 0)             shipMsgEl.textContent = 'Your cart is empty.';
      else if (qty >= FREE_QTY) shipMsgEl.textContent = '🎉 You’ve unlocked free shipping!';
      else { var need = FREE_QTY - qty; shipMsgEl.textContent = 'Add ' + need + ' more ' + (need === 1 ? 'bottle' : 'bottles') + ' for free shipping.'; }
    }
    if (checkoutBtnEl) checkoutBtnEl.disabled = qty <= 0;
    if (decBtn) decBtn.disabled = qty <= 0;
  }
  // Paint from a cart object we already hold. change.js returns the updated cart,
  // so the old follow-up GET /cart.js after every write is unnecessary.
  function paintCart(cart){
    var qty = 0;
    ourKey = '';
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++){
        var it = cart.items[i];
        if (it.variant_id === cfg.variantId){
          qty += it.quantity;
          // Our line carries properties, so its key is `variantId:hash` — the
          // only identifier change.js will accept for it.
          if (!ourKey){ ourKey = it.key; if (cartNameEl) cartNameEl.textContent = it.product_title; }
        }
      }
    }
    shownQty = lastWritten = qty;
    paintQty(qty);
    return qty;
  }
  function renderDrawer(){ return getCart().then(paintCart); }

  // Write an ABSOLUTE quantity for our bottle; resolves to the updated cart.
  function writeQty(qty){
    if (ourKey) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: ourKey, quantity: qty })
      }).then(function(r){
        if (!r.ok) return r.text().then(function(t){ throw new Error('change.js ' + r.status + ': ' + t); });
        return r.json();
      });
    }
    if (qty <= 0) return getCart();                 // nothing of ours to remove
    return addToCart(qty).then(getCart);            // add.js creates the line
  }

  function addToCart(qty) {
    if (!cfg.available || !cfg.variantId) {
      if (cfg.designMode) { alert('Select the product in the section settings to enable checkout.'); }
      else { window.location.href = '/cart'; }
      return Promise.reject();
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: qty || 1, properties: attribution }] })
    }).then(function(r){ return r.json(); }).then(function(){
      // persist attribution as cart-level attributes too
      fetch('/cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attribution })
      });
      track('AddToCart', 'add_to_cart', { items: [{ item_id: cfg.variantId, quantity: qty || 1 }] });
    });
  }

  function setLoading(el, on){ if (el) el.classList.toggle('is-loading', !!on); }

  // Reset any stuck spinners when returning via the browser back button
  // (bfcache restore fires pageshow but not DOMContentLoaded).
  window.addEventListener('pageshow', function () {
    var loaders = document.querySelectorAll('.is-loading');
    for (var i = 0; i < loaders.length; i++) { loaders[i].classList.remove('is-loading'); }
  });

  // Show the sync spinner while any cart write is in flight (ref-counted, since
  // rapid clicks can overlap).
  var cartLineEl = drawer ? drawer.querySelector('.dcv-cart-line') : null;
  var syncCount = 0;
  function setSyncing(on){
    syncCount = Math.max(0, syncCount + (on ? 1 : -1));
    if (cartLineEl) cartLineEl.classList.toggle('is-syncing', syncCount > 0);
  }

  // Buy buttons: open the drawer immediately (so the click never feels dead),
  // then make sure the bottle is in the cart without stacking on repeat clicks.
  document.querySelectorAll('[data-atc]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (btn.classList.contains('is-loading')) return;
      setLoading(btn, true);
      openDrawer();
      setSyncing(true);
      getCart()
        .then(function(cart){ return paintCart(cart) < 1 ? addToCart(1).then(getCart).then(paintCart) : null; })
        .then(function(){ setLoading(btn, false); setSyncing(false); })
        .catch(function(){ setLoading(btn, false); setSyncing(false); });
    });
  });

  // Drawer quantity stepper (+ adds a bottle, − removes one; 0 clears the line).
  // Optimistic and coalesced: the number moves on click, writes are serialised,
  // and each write sends an absolute quantity — so three fast clicks collapse
  // into ONE request carrying the final value instead of three round trips.
  var stepChain = Promise.resolve();
  function step(delta){
    var target = Math.max(0, shownQty + delta);
    if (target === shownQty) return;
    shownQty = target;
    paintQty(target);                                  // instant feedback
    if (delta > 0) track('AddToCart', 'add_to_cart', { items: [{ item_id: cfg.variantId, quantity: delta }] });
    setSyncing(true);
    stepChain = stepChain
      .then(function(){
        if (shownQty === lastWritten) return null;      // already coalesced away
        lastWritten = shownQty;
        return writeQty(shownQty);
      })
      .then(function(cart){ if (cart) paintCart(cart); })
      .catch(function(){ return renderDrawer(); })      // resync from the server
      .then(function(){ setSyncing(false); });
  }
  if (incBtn) incBtn.addEventListener('click', function(){ step(1); });
  if (decBtn) decBtn.addEventListener('click', function(){ if (!decBtn.disabled) step(-1); });

  function goCheckout(){
    track('InitiateCheckout', 'begin_checkout', {});
    window.location.href = '/checkout';
  }
  var checkoutBtn = document.querySelector('[data-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function(){
    if (checkoutBtn.disabled || checkoutBtn.classList.contains('is-loading')) return;
    setLoading(checkoutBtn, true);                  // stays spinning until checkout page loads
    goCheckout();
  });
  Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-close]'), function(el){
    el.addEventListener('click', closeDrawer);
  });
  if (drawer) drawer.addEventListener('click', function(e){ if (e.target === drawer) closeDrawer(); });

  // ---------- Sticky bar (appears when hero CTA scrolls out of view, §3) ----------
  var sb = document.getElementById('dcv-shopbar');
  var heroBtn = document.querySelector('.hero [data-atc]');
  if (sb && heroBtn) {
    var updateBar = function(){
      var r = heroBtn.getBoundingClientRect();
      sb.classList.toggle('show', r.bottom <= 0);   // show once the hero CTA is above the viewport
    };
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    updateBar();
  }

  // ---------- "Our story" accordion (§4) ----------
  var accToggle = document.querySelector('[data-accordion-toggle]');
  var acc = document.querySelector('[data-accordion]');
  if (accToggle && acc) accToggle.addEventListener('click', function(){
    var open = !acc.hidden; acc.hidden = open;
    accToggle.textContent = open ? 'Read more' : 'Read less';
  });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
